import { useTheme } from '@mui/material'

const useThemeMode = () => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  return { theme, isDark }
}

export default useThemeMode
